/** Keys carry the office id, so each location caches apart from the selected one. */
export const locationSettingsKeys = {
  all: ['locationSettings'] as const,
  office: (officeId: string) => [...locationSettingsKeys.all, 'office', officeId] as const,
  credentials: (officeId: string) =>
    [...locationSettingsKeys.all, 'credentials', officeId] as const,
  workerClassification: (officeId: string) =>
    [...locationSettingsKeys.all, 'workerClassification', officeId] as const,
};
